export const buildTargetUserParams = (targetUserId, targetPracticeId) => {
  if (!targetUserId) return {};

  return {
    target_user_id: targetUserId,
    ...(targetPracticeId ? { practice_id: targetPracticeId } : {})
  };
};
